export default {
	locationNotConnectedToRanglisten:
		"Your currently selected location is not connected to Ranglisten, please select a PadelPadel location.",
	openRanglisten: "Go to Ranglisten",
};
